import React from 'react';
import type { Size } from '../../types';

const pack = (width: Size = '300', height: Size = '398') => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 300 398"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M296.004 225.257C299.318 198.067 294.495 170.505 282.146 146.056C269.796 121.608 250.475 101.369 226.624 87.9006C202.773 74.432 175.465 68.3379 148.151 70.3889C120.837 72.4398 94.7442 82.5437 73.1722 99.4229C51.6003 116.302 35.5176 139.199 26.9578 165.218C18.398 191.237 17.7454 219.21 25.0825 245.6C32.4196 271.99 47.4169 295.611 68.1782 313.478C88.9396 331.345 114.533 342.655 141.721 345.977C159.779 348.184 178.094 346.812 195.621 341.939C213.148 337.066 229.543 328.788 243.87 317.577C258.197 306.367 270.175 292.444 279.12 276.603C288.066 260.763 293.803 243.315 296.004 225.257Z"
                fill="#EDC418"
            />
            <path
                d="M133.959 106.759L25.156 114.682L19.9059 127.373L135.344 116.422L133.959 106.759Z"
                fill="url(#paint0_linear_10025_65883)"
            />
            <path
                d="M133.959 144.669L36.0424 149.984L19.9377 127.437L135.344 116.422L133.959 144.669Z"
                fill="url(#paint1_linear_10025_65883)"
            />
            <path
                d="M147.777 136.359L36.0425 148.857L60.5215 164.349L170.194 152.078C170.342 152.054 170.48 151.987 170.589 151.884C170.698 151.781 170.773 151.647 170.804 151.501C170.836 151.354 170.822 151.202 170.765 151.063C170.708 150.924 170.61 150.806 170.484 150.725L147.777 136.359Z"
                fill="url(#paint2_linear_10025_65883)"
            />
            <path
                d="M147.777 136.359L36.0425 148.856L20.8075 126.567L135.344 116.422L147.777 136.359Z"
                fill="url(#paint3_linear_10025_65883)"
            />
            <path
                d="M133.959 106.759L25.1558 114.682L20.8075 126.568L135.344 116.422L133.959 106.759Z"
                fill="url(#paint4_linear_10025_65883)"
            />
            <path
                d="M147.777 136.359L36.0425 148.857L60.5215 164.349L170.033 152.078C170.2 152.067 170.359 152.002 170.487 151.893C170.614 151.784 170.702 151.637 170.738 151.474C170.775 151.31 170.757 151.139 170.688 150.987C170.619 150.834 170.502 150.709 170.355 150.628L147.777 136.359ZM40.7128 149.919L147.39 138.002L167.585 150.886L60.8758 162.707L40.7128 149.919Z"
                fill="url(#paint5_linear_10025_65883)"
            />
            <path
                d="M154.058 272.379V139.612C154.063 138.956 153.928 138.305 153.661 137.705C153.394 137.105 153.002 136.568 152.511 136.132C152.019 135.696 151.441 135.37 150.813 135.176C150.186 134.981 149.524 134.924 148.872 135.007L55.465 143.542C54.065 143.667 52.7588 144.299 51.792 145.319C50.8252 146.339 50.2643 147.677 50.2149 149.082V281.881C50.209 282.537 50.3442 283.186 50.6113 283.785C50.8784 284.384 51.2712 284.918 51.7631 285.352C52.2549 285.786 52.8343 286.109 53.4619 286.299C54.0895 286.489 54.7507 286.542 55.4006 286.455L148.808 277.919C150.208 277.794 151.514 277.162 152.481 276.142C153.447 275.122 154.008 273.784 154.058 272.379Z"
                fill="url(#paint6_linear_10025_65883)"
            />
            <path
                d="M148.421 270.382V137.583C148.422 136.929 148.283 136.282 148.014 135.686C147.745 135.089 147.352 134.557 146.862 134.124C146.371 133.692 145.794 133.368 145.169 133.176C144.543 132.984 143.884 132.927 143.235 133.009L49.8283 141.545C48.4373 141.678 47.1427 142.314 46.1878 143.334C45.2328 144.354 44.6834 145.688 44.6426 147.085V279.852C44.6374 280.508 44.7727 281.159 45.0396 281.759C45.3064 282.359 45.6985 282.896 46.1897 283.332C46.6809 283.768 47.2596 284.094 47.8872 284.288C48.5148 284.483 49.1766 284.54 49.8283 284.458L143.235 275.922C144.624 275.783 145.914 275.144 146.868 274.125C147.822 273.107 148.373 271.777 148.421 270.382Z"
                fill="url(#paint7_linear_10025_65883)"
            />
            <path
                d="M150.321 271.542V138.743C150.322 138.089 150.183 137.442 149.914 136.845C149.645 136.249 149.253 135.717 148.762 135.284C148.271 134.851 147.694 134.528 147.069 134.336C146.444 134.144 145.784 134.087 145.136 134.169L51.7285 142.705C50.3343 142.837 49.0359 143.472 48.0757 144.491C47.1155 145.511 46.5592 146.845 46.5106 148.245V281.011C46.5054 281.668 46.6408 282.319 46.9076 282.919C47.1744 283.519 47.5666 284.055 48.0577 284.492C48.5489 284.928 49.1277 285.254 49.7552 285.448C50.3828 285.642 51.0447 285.7 51.6963 285.617L145.103 277.082C146.5 276.956 147.802 276.323 148.764 275.302C149.726 274.281 150.28 272.944 150.321 271.542Z"
                fill="url(#paint8_linear_10025_65883)"
            />
            <path
                d="M152.672 272.766V139.967C152.673 139.312 152.534 138.666 152.265 138.069C151.997 137.473 151.604 136.941 151.113 136.508C150.623 136.075 150.045 135.752 149.42 135.56C148.795 135.367 148.136 135.311 147.487 135.393L54.0798 143.928C52.6887 144.061 51.3941 144.698 50.4392 145.718C49.4843 146.738 48.9348 148.072 48.8941 149.468V282.235C48.8888 282.892 49.0242 283.542 49.291 284.143C49.5579 284.743 49.95 285.279 50.4412 285.715C50.9323 286.152 51.5111 286.478 52.1387 286.672C52.7662 286.866 53.4281 286.924 54.0798 286.841L147.487 278.306C148.878 278.173 150.172 277.536 151.127 276.516C152.082 275.496 152.632 274.162 152.672 272.766Z"
                fill="url(#paint9_linear_10025_65883)"
            />
            <path
                d="M154.218 273.861V141.094C154.224 140.437 154.088 139.787 153.821 139.186C153.555 138.586 153.162 138.05 152.671 137.614C152.18 137.177 151.601 136.851 150.974 136.657C150.346 136.463 149.684 136.405 149.033 136.488L55.6257 145.024C54.2373 145.163 52.9465 145.801 51.9929 146.82C51.0393 147.839 50.4876 149.169 50.44 150.564V283.362C50.4341 284.018 50.5693 284.668 50.8364 285.267C51.1035 285.865 51.4963 286.4 51.9882 286.834C52.48 287.268 53.0594 287.59 53.687 287.781C54.3146 287.971 54.9758 288.024 55.6257 287.936L149.033 279.401C150.421 279.261 151.712 278.623 152.665 277.604C153.619 276.585 154.171 275.255 154.218 273.861Z"
                fill="url(#paint10_linear_10025_65883)"
            />
            <path
                d="M156.022 275.02V142.189C156.028 141.532 155.892 140.882 155.625 140.282C155.359 139.681 154.966 139.145 154.475 138.709C153.984 138.273 153.405 137.947 152.778 137.752C152.15 137.558 151.488 137.501 150.837 137.583L57.4298 146.119C56.0234 146.278 54.7256 146.951 53.7861 148.01C52.8466 149.068 52.3317 150.437 52.3407 151.852V284.522C52.3401 285.176 52.4788 285.823 52.7477 286.42C53.0165 287.016 53.4093 287.548 53.8999 287.981C54.3906 288.414 54.9677 288.737 55.593 288.929C56.2183 289.121 56.8774 289.178 57.5264 289.096L150.933 280.56C152.307 280.406 153.578 279.76 154.514 278.742C155.449 277.724 155.985 276.402 156.022 275.02Z"
                fill="url(#paint11_linear_10025_65883)"
            />
            <path
                d="M158.213 276.212V143.445C158.2 142.799 158.051 142.163 157.776 141.579C157.501 140.994 157.107 140.473 156.617 140.051C156.128 139.629 155.556 139.314 154.937 139.128C154.319 138.941 153.668 138.887 153.027 138.968L59.8776 147.375C58.4859 147.514 57.1913 148.151 56.2324 149.169C55.2735 150.187 54.7149 151.517 54.6597 152.915V285.714C54.6436 286.378 54.7726 287.038 55.0374 287.647C55.3023 288.257 55.6968 288.801 56.1934 289.242C56.6901 289.684 57.2769 290.012 57.9132 290.203C58.5494 290.395 59.2197 290.446 59.8776 290.352L153.285 281.816C154.64 281.624 155.881 280.954 156.785 279.926C157.689 278.898 158.195 277.581 158.213 276.212Z"
                fill="url(#paint12_linear_10025_65883)"
            />
            <path
                d="M160.854 277.468V144.702C160.86 144.046 160.724 143.396 160.457 142.797C160.19 142.199 159.797 141.664 159.306 141.23C158.814 140.796 158.234 140.473 157.607 140.283C156.979 140.093 156.318 140.04 155.668 140.128L62.3577 148.631C60.9667 148.764 59.6721 149.4 58.7172 150.42C57.7623 151.441 57.2128 152.774 57.172 154.171V287.131C57.1668 287.788 57.3021 288.438 57.569 289.039C57.8358 289.639 58.228 290.175 58.7191 290.611C59.2103 291.048 59.7891 291.374 60.4166 291.568C61.0442 291.762 61.706 291.82 62.3577 291.737L155.765 283.169C157.165 283.011 158.459 282.342 159.398 281.29C160.336 280.239 160.855 278.878 160.854 277.468Z"
                fill="url(#paint13_linear_10025_65883)"
            />
            <path
                d="M163.366 278.499V145.7C163.366 145.046 163.228 144.399 162.959 143.803C162.69 143.206 162.297 142.674 161.806 142.241C161.316 141.808 160.739 141.485 160.113 141.293C159.488 141.101 158.829 141.044 158.18 141.126L64.773 149.662C63.4148 149.806 62.1525 150.43 61.2136 151.422C60.2747 152.414 59.7209 153.709 59.6518 155.073V287.968C59.6465 288.625 59.7819 289.276 60.0487 289.876C60.3156 290.476 60.7077 291.012 61.1989 291.449C61.69 291.885 62.2688 292.211 62.8964 292.405C63.5239 292.599 64.1858 292.657 64.8375 292.574L158.244 284.039C159.621 283.885 160.897 283.24 161.837 282.223C162.777 281.205 163.32 279.884 163.366 278.499Z"
                fill="url(#paint14_linear_10025_65883)"
            />
            <path
                d="M165.878 217.172V84.3733C165.88 83.7161 165.74 83.0661 165.469 82.4672C165.199 81.8683 164.803 81.3343 164.309 80.9011C163.814 80.4678 163.233 80.1454 162.604 79.9554C161.975 79.7654 161.312 79.7123 160.661 79.7996L67.2536 88.3351C65.88 88.4899 64.6086 89.1357 63.6734 90.1537C62.7383 91.1717 62.2025 92.4933 62.1646 93.8751V226.642C62.164 227.3 62.3035 227.951 62.574 228.551C62.8445 229.152 63.2397 229.687 63.7333 230.123C64.2269 230.559 64.8076 230.885 65.4368 231.078C66.066 231.272 66.7292 231.33 67.3825 231.248L160.693 222.712C162.084 222.579 163.378 221.943 164.333 220.923C165.288 219.903 165.838 218.569 165.878 217.172Z"
                fill="url(#paint15_linear_10025_65883)"
            />
            <path
                d="M137.307 184.176C155.1 171.23 159.733 147.278 147.655 130.679C135.578 114.08 111.363 111.119 93.5695 124.065C75.7764 137.012 71.1432 160.963 83.221 177.562C95.2987 194.162 119.514 197.123 137.307 184.176Z"
                fill="url(#paint16_linear_10025_65883)"
            />
            <path
                d="M134.666 135.006L114.246 136.745L114.342 141.448L110.445 141.77L101.813 142.511L102.006 151.529L96.8206 151.98L96.9816 159.614L97.046 161.707L97.0782 163.254L102.232 162.835L102.844 192.854L117.112 191.662L116.919 183.223L131.703 181.967L131.607 177.297L135.504 176.975L134.666 135.006Z"
                fill="#BCFAFF"
            />
            <path
                d="M125.133 157.391L121.396 157.713L121.622 167.956L125.358 167.634L125.133 157.391Z"
                fill="#76E4E7"
            />
            <path
                d="M104.325 152.366L100.621 152.689V156.199L104.358 155.877L104.325 152.366Z"
                fill="#76E4E7"
            />
            <path
                d="M114.922 171.66L131.832 170.211L131.896 173.882L114.987 175.3L114.922 171.66Z"
                fill="#041836"
            />
            <path
                d="M100.653 156.006L96.917 156.296L96.8526 153.011L100.589 152.689L100.524 149.21L96.7882 149.532L96.8526 153.011L93.1163 153.333L93.1808 156.811L96.917 156.489L97.0781 163.253L100.621 162.963L101.265 193.176L105.002 192.854L104.293 159.002L100.718 159.292L100.653 156.006Z"
                fill="#041836"
            />
            <path
                d="M131.864 180.324L118.691 181.419L115.115 181.741H114.954L115.148 191.984L118.884 191.694L118.755 185.059L132.09 183.932L132.025 180.453L135.601 180.163L135.536 176.717L131.8 177.007L131.864 180.324Z"
                fill="#041836"
            />
            <path
                d="M141.656 145.57L138.628 145.828L138.435 135.908L134.699 136.23L134.892 146.15L131.156 146.44L127.935 146.73L121.171 147.31L117.982 147.567L110.67 148.179L107.449 148.469L104.261 148.727L104.132 142.317L100.396 142.607L100.589 152.689L104.325 152.367L107.546 152.109L107.611 155.394L110.831 155.137L110.896 158.583L118.207 157.971L118.111 154.492L121.332 154.235L121.235 150.949L128.031 150.37L128.096 153.655L131.284 153.397L131.381 156.876L135.117 156.554L135.536 176.717L139.272 176.395L138.789 152.753L141.785 152.495L141.656 145.57Z"
                fill="#041836"
            />
            <path
                d="M138.274 128.983L134.538 129.273L134.473 125.987L106.87 128.338L106.934 131.463L103.552 131.753L103.617 135.392L100.235 135.682L100.299 139.161L93.3743 139.741L90.3466 139.998L89.799 140.03L86.0627 140.353L86.1594 143.831L89.8957 143.509L90.0889 153.591L93.6641 153.301L93.5675 149.79L96.7884 149.532L96.724 146.569L100.46 146.279L100.396 142.8L103.778 142.511L107.16 142.221L120.688 141.061L120.784 144.733L131.639 143.799L131.574 140.159L134.763 139.869L134.699 136.391L138.435 136.101L138.274 128.983Z"
                fill="#49B6C8"
            />
            <path
                d="M65.5141 318.761L60.5217 164.349L36.0426 148.857L35.7205 297.567C35.5935 299.675 36.1069 301.772 37.1933 303.582C38.2798 305.393 39.8884 306.833 41.8081 307.713L65.5141 318.761Z"
                fill="url(#paint17_linear_10025_65883)"
            />
            <path
                d="M65.5141 318.761L0.805664 301.496V253.182L35.8172 254.922V297.728C35.6901 299.836 36.2035 301.933 37.29 303.744C38.3764 305.554 39.9851 306.994 41.9047 307.874L65.5141 318.761Z"
                fill="url(#paint18_linear_10025_65883)"
            />
            <path
                d="M168.648 149.565L60.8758 162.707L40.6806 149.919L36.0425 148.857L60.5215 164.349L168.745 153.946H172.223L172.062 151.723L168.648 149.565Z"
                fill="url(#paint19_linear_10025_65883)"
            />
            <path
                d="M172.224 154.236L171.901 298.855C171.91 301.343 171.001 303.746 169.35 305.606C167.698 307.466 165.418 308.652 162.947 308.937L69.9269 319.34C68.7064 319.477 67.4708 319.353 66.3015 318.978C65.1321 318.602 64.0556 317.983 63.1428 317.162C62.2299 316.34 61.5014 315.335 61.0052 314.211C60.5091 313.088 60.2565 311.872 60.2641 310.644L60.5862 164.349L114.376 158.294L169.84 152.078C170.143 152.04 170.45 152.069 170.741 152.161C171.032 152.253 171.299 152.407 171.525 152.612C171.751 152.816 171.931 153.067 172.051 153.348C172.172 153.628 172.23 153.931 172.224 154.236Z"
                fill="url(#paint20_linear_10025_65883)"
            />
            <path
                d="M75.5312 309.903C73.88 309.902 72.2866 309.295 71.0541 308.196C70.3545 307.573 69.7947 306.809 69.4117 305.954C69.0286 305.099 68.8309 304.172 68.8317 303.235L69.186 178.167C69.1917 176.522 69.8021 174.937 70.9009 173.714C71.9997 172.49 73.5102 171.714 75.1447 171.532L156.022 162.449C156.96 162.352 157.909 162.451 158.807 162.74C159.705 163.028 160.533 163.499 161.24 164.124C161.944 164.75 162.506 165.52 162.889 166.38C163.272 167.241 163.468 168.174 163.463 169.116L163.205 293.251C163.21 294.911 162.606 296.516 161.508 297.763C160.41 299.009 158.894 299.81 157.246 300.015L76.272 309.871L75.5312 309.903ZM75.2413 172.273C73.8033 172.445 72.4771 173.135 71.5109 174.214C70.5446 175.292 70.0044 176.686 69.9912 178.135L69.5403 303.235C69.5362 304.057 69.7048 304.869 70.0349 305.621C70.3651 306.373 70.8495 307.047 71.4569 307.6C72.0642 308.153 72.7808 308.571 73.5604 308.829C74.3399 309.087 75.165 309.179 75.9821 309.098L157.15 299.145C158.593 298.958 159.92 298.255 160.885 297.166C161.85 296.076 162.388 294.674 162.4 293.218L162.657 169.084C162.652 168.266 162.476 167.457 162.143 166.71C161.809 165.963 161.325 165.293 160.72 164.742C160.115 164.192 159.402 163.772 158.627 163.511C157.852 163.249 157.031 163.151 156.215 163.222L75.2413 172.273Z"
                fill="url(#paint21_linear_10025_65883)"
            />
            <path
                d="M162.947 308.937L99.6237 316.119L83.809 317.891L75.9821 318.696L72.0204 319.115C70.7131 319.345 69.3846 319.431 68.0586 319.372C66.7477 319.201 65.4907 318.743 64.3772 318.03C63.2637 317.318 62.3212 316.368 61.6168 315.25C60.9144 314.118 60.4844 312.839 60.3606 311.513C60.3606 310.193 60.3606 308.872 60.3606 307.551V291.64L60.6505 164.349C60.9404 185.543 61.2302 206.769 61.198 227.995L61.3913 291.64V307.551C61.3913 308.808 61.3913 310.322 61.3913 311.417C61.4846 312.559 61.849 313.664 62.4542 314.638C63.0685 315.631 63.8956 316.476 64.8759 317.111C65.8562 317.746 66.9653 318.155 68.123 318.309C68.7131 318.342 69.3045 318.342 69.8946 318.309L71.8915 318.084L75.8211 317.665L83.7445 316.86L99.5593 315.185L131.221 311.964L162.947 308.937Z"
                fill="url(#paint22_linear_10025_65883)"
            />
            <path
                d="M60.5219 164.349L124.683 157.166L156.892 153.559L164.912 152.657L168.906 152.206C169.566 152.077 170.244 152.077 170.903 152.206C171.221 152.316 171.509 152.498 171.744 152.738C171.978 152.979 172.154 153.271 172.256 153.591C172.449 158.97 172.256 164.349 172.256 169.696L171.966 298.823C171.708 277.307 171.451 255.791 171.483 234.404L171.322 169.825V155.62C171.364 155.052 171.364 154.481 171.322 153.913C171.268 153.744 171.177 153.589 171.054 153.46C170.931 153.332 170.78 153.233 170.613 153.172C170.434 153.121 170.245 153.121 170.066 153.172H169.067L165.041 153.591L157.021 154.461L124.812 157.682L92.6023 161.096L60.5219 164.349Z"
                fill="url(#paint23_linear_10025_65883)"
            />
            <path
                d="M153.124 228.735L153.285 235.338L146.295 236.047L146.811 256.628L140.369 257.305L139.821 236.659L132.799 237.367L132.606 230.732L153.124 228.735Z"
                fill="url(#paint24_linear_10025_65883)"
            />
            <path
                d="M104.488 233.438L105.228 260.913L99.4629 261.525L88.8016 247.417L89.2525 262.555L82.6496 263.232L81.8766 235.596L88.0608 235.016L98.3355 248.609L97.949 234.05L104.488 233.438Z"
                fill="url(#paint25_linear_10025_65883)"
            />
            <path
                d="M129.289 231.055L129.45 237.69L117.146 238.882L117.275 243.552L128.387 242.457L128.58 248.705L117.436 249.833L117.693 259.624L111.123 260.301L110.382 232.858L129.289 231.055Z"
                fill="url(#paint26_linear_10025_65883)"
            />
            <path
                d="M153.703 262.942L147.616 271.992L154.444 282.46L148.872 283.04L144.459 276.212L142.817 278.563L142.945 283.62L138.307 284.103L137.792 264.488L142.43 264.037L142.656 271.992L148.196 263.489L153.703 262.942Z"
                fill="url(#paint27_linear_10025_65883)"
            />
            <path
                d="M127.259 265.132C128.05 265.017 128.852 265.017 129.643 265.132C130.325 265.253 130.986 265.47 131.607 265.776C132.199 266.095 132.751 266.484 133.25 266.935C133.738 267.399 134.171 267.918 134.539 268.481L131.124 271.96C130.889 271.65 130.619 271.369 130.319 271.122C130.066 270.862 129.772 270.645 129.449 270.478C128.819 270.105 128.081 269.957 127.356 270.06C126.769 270.114 126.205 270.314 125.713 270.639C125.212 270.953 124.783 271.37 124.457 271.863C124.11 272.399 123.849 272.986 123.684 273.603C123.497 274.273 123.41 274.968 123.426 275.664C123.455 276.364 123.574 277.056 123.781 277.725C123.976 278.305 124.282 278.841 124.682 279.304C125.009 279.745 125.437 280.102 125.93 280.343C126.424 280.584 126.968 280.703 127.517 280.689C127.922 280.63 128.322 280.533 128.709 280.399C129.052 280.244 129.377 280.05 129.675 279.819C129.97 279.556 130.25 279.277 130.512 278.982C130.792 278.64 131.04 278.273 131.253 277.886L134.861 280.463C134.487 281.125 134.067 281.761 133.604 282.364C133.133 282.953 132.593 283.483 131.994 283.942C131.386 284.411 130.713 284.791 129.997 285.069C129.189 285.374 128.344 285.569 127.485 285.649C126.399 285.719 125.312 285.554 124.296 285.166C123.223 284.779 122.253 284.151 121.462 283.33C120.601 282.47 119.931 281.439 119.497 280.302C118.982 279.032 118.709 277.678 118.692 276.308C118.653 274.922 118.849 273.539 119.271 272.218C119.654 270.947 120.266 269.758 121.075 268.707C121.832 267.72 122.773 266.889 123.845 266.259C124.894 265.653 126.056 265.269 127.259 265.132Z"
                fill="url(#paint28_linear_10025_65883)"
            />
            <path
                d="M109.866 267.064L117.661 286.39L112.604 286.905L111.412 283.33L104.681 283.91L103.553 287.549L98.5286 288.161L105.26 267.515L109.866 267.064ZM105.937 279.594L109.802 279.207L107.74 273.796L105.937 279.594Z"
                fill="url(#paint29_linear_10025_65883)"
            />
            <path
                d="M90.7017 269.061C91.6933 268.96 92.6949 269.025 93.6649 269.255C94.5054 269.462 95.2874 269.859 95.9518 270.414C96.6129 270.971 97.1319 271.678 97.4656 272.476C98.1797 274.431 98.1797 276.576 97.4656 278.531C97.1624 279.422 96.6676 280.235 96.0162 280.914C95.3614 281.604 94.5721 282.152 93.6971 282.525C92.7636 282.926 91.7759 283.186 90.7661 283.298L88.3826 283.523L88.5436 289.192L83.7767 289.675L83.1969 269.802L90.7017 269.061ZM93.2784 276.115C93.2785 275.739 93.2018 275.366 93.0529 275.02C92.9362 274.722 92.7482 274.456 92.5054 274.247C92.2348 274.05 91.9285 273.908 91.6035 273.828C91.2188 273.776 90.8287 273.776 90.444 273.828L88.2215 274.054V279.304L90.5084 279.078C90.8987 279.051 91.2807 278.953 91.6357 278.789C91.9522 278.641 92.2367 278.433 92.4732 278.177C92.7052 277.927 92.8809 277.63 92.9885 277.307C93.1121 276.956 93.1667 276.584 93.1496 276.212"
                fill="url(#paint30_linear_10025_65883)"
            />
            <path
                d="M140.304 214.885L119.207 178.424L95.3398 220.908L140.304 214.885Z"
                fill="url(#paint31_linear_10025_65883)"
            />
            <path
                d="M140.304 214.885L119.207 178.424L119.626 204.707L140.304 214.885Z"
                fill="url(#paint32_linear_10025_65883)"
            />
            <path
                d="M140.304 214.885L119.207 178.424L119.626 204.707L140.304 214.885Z"
                fill="url(#paint33_linear_10025_65883)"
            />
            <path
                d="M119.626 204.707L119.207 178.424L95.3398 220.908L119.626 204.707Z"
                fill="url(#paint34_linear_10025_65883)"
            />
            <path
                d="M95.3076 220.908L140.207 214.467L139.917 215.046L119.207 178.424L140.658 214.692C140.724 214.768 140.76 214.865 140.76 214.966C140.76 215.066 140.724 215.164 140.658 215.24H140.401L95.3076 220.908Z"
                fill="url(#paint35_linear_10025_65883)"
            />
            <path
                d="M264.439 340.373L105.84 333.416L159.146 320.854L234.742 276.405V319.211C234.614 321.311 235.124 323.4 236.205 325.205C237.285 327.01 238.886 328.446 240.797 329.325L264.439 340.373Z"
                fill="url(#paint36_linear_10025_65883)"
            />
            <path
                d="M268.284 335.469L289.931 181.444C290.387 178.203 288.129 175.206 284.887 174.75L179.44 159.931C176.198 159.475 173.202 161.733 172.746 164.975L151.099 319C150.644 322.241 152.902 325.238 156.143 325.693L261.591 340.513C264.832 340.968 267.829 338.71 268.284 335.469Z"
                fill="url(#paint37_linear_10025_65883)"
            />
            <path
                d="M221.311 291.705C246.802 291.705 267.466 271.04 267.466 245.549C267.466 220.057 246.802 199.393 221.311 199.393C195.819 199.393 175.155 220.057 175.155 245.549C175.155 271.04 195.819 291.705 221.311 291.705Z"
                fill="#1EC5F9"
            />
            <path
                d="M239.541 276.244C242.762 260.816 253.649 219.524 228.268 217.817C222.755 217.469 217.24 218.459 212.193 220.702C207.146 222.946 202.715 226.376 199.279 230.7C196.61 234.331 194.158 238.117 191.936 242.038C190.723 244.277 189.356 246.43 187.845 248.48C187.649 248.976 187.424 249.46 187.169 249.929C187.083 252.511 186.051 254.971 184.269 256.842C182.487 258.713 180.08 259.863 177.506 260.075C179.572 266.404 182.984 272.21 187.508 277.094C192.032 281.978 197.56 285.824 203.712 288.368C209.864 290.911 216.495 292.092 223.147 291.828C229.799 291.565 236.315 289.863 242.247 286.841C240.989 285.415 240.088 283.711 239.618 281.868C239.148 280.026 239.121 278.099 239.541 276.244Z"
                fill="#2E7EAF"
            />
            <path
                d="M249.59 260.88L247.304 260.558L251.33 231.924L207.879 225.804L201.083 273.86L244.566 279.98L246.144 268.771L248.431 269.093L249.59 260.88Z"
                fill="#BCFAFF"
            />
            <path
                d="M259.318 228.768L258.673 233.567L250.396 232.407L227.366 229.154V229.122L217.993 227.801V227.833L198.603 225.096L199.247 220.458L202.339 220.876L204.594 221.198L204.916 218.879L206.365 219.105L207.074 214.177L209.619 214.531L209.973 211.986L215.03 212.695L215.352 210.344L222.148 211.31L222.47 208.894L236.868 210.924L236.546 213.339L243.857 214.37L243.535 216.721L245.983 217.076L245.629 219.427L247.948 219.749L247.561 222.326L249.88 222.68L249.494 225.225L252.167 225.611L251.877 227.737L259.318 228.768Z"
                fill="#DF7DE2"
            />
            <path
                d="M244.308 278.982L243.76 282.783L240.894 282.364V282.75L237.351 282.235L236.932 285.23L227.656 283.91L227.463 285.198L230.265 285.585L230.039 287.002L220.924 285.746L207.493 283.91L207.783 281.784L200.117 280.689L200.6 277.178L197.766 276.792L198.249 273.571L194.802 273.088L195.318 269.512L192.87 269.19L193.353 265.647L189.778 265.132L190.261 261.589L179.696 260.075L180.501 254.406L182.434 254.696L183.014 250.444L184.753 250.67L186.331 239.397L188.972 239.751L189.488 236.337L191.936 236.691L192.29 234.243L195.06 234.63L195.414 232.085L197.766 232.407L198.41 227.801L217.735 230.507L217.381 232.955L212.389 232.246L212.099 234.436L200.31 232.761L199.988 235.016L197.476 234.662L197.121 237.11L194.577 236.723L194.158 239.493L191.807 239.171L190.357 248.48L192.741 248.802L192.354 251.475L195.157 251.701L194.802 254.148L197.315 254.503L197.025 256.693L203.853 257.659L204.143 255.469L206.752 255.856L207.138 253.086L204.53 252.731L204.143 255.469L197.315 254.503L197.669 252.055L195.157 251.701L195.543 249.027L192.805 248.641L194.126 239.171L196.703 239.525L197.089 236.788L201.598 237.528L201.212 240.105L206.527 240.846L206.881 238.301L208.91 238.559L207.557 248.222L209.522 248.48L209.2 250.928L211.648 251.25L211.358 253.472L219.024 254.535L218.669 257.015L216.254 256.693L215.899 259.302L213.387 258.948L212.067 268.353L214.579 268.707L214.225 271.219L216.544 271.542L216.189 274.118L218.637 274.44L218.347 276.47L239.283 279.433L239.573 277.404L242.15 277.79L242.536 275.213L244.92 275.568L244.405 279.111L244.308 278.982ZM202.436 249.993L202.758 247.61L200.568 247.288L200.89 245.065L203.08 245.355L203.402 243.004L198.99 242.36L198.023 249.349L202.436 249.993Z"
                fill="#2E7EAF"
            />
            <path
                d="M249.913 236.015L249.719 237.335L248.141 237.11L248.495 234.662L250.041 234.887L249.913 236.015Z"
                fill="#2E7EAF"
            />
            <path
                d="M241.312 233.664L240.958 236.112L238.091 235.693L237.769 237.883L235.933 237.625L233.518 237.271L231.166 236.949L231.488 234.759L226.657 234.082L227.011 231.635L241.312 233.664Z"
                fill="#2E7EAF"
            />
            <path
                d="M207.461 250.573L204.852 250.187L205.174 247.836L202.629 247.481L202.307 249.833L198.893 249.349L199.537 244.743L205.754 245.645L206.43 240.814L201.148 240.073L201.502 237.529L196.993 236.917L196.638 239.429L194.126 239.075L193.45 243.874L192.644 249.414L195.382 249.8L195.028 252.28L197.54 252.635L197.154 255.437L201.438 256.049L203.982 256.403L204.369 253.601L206.978 253.955L207.461 250.573Z"
                fill="#BCFAFF"
            />
            <path
                d="M259.344 228.865L258.667 233.649L260.581 233.92L261.257 229.136L259.344 228.865Z"
                fill="#041836"
            />
            <path
                d="M258.319 236.08L258.158 237.175L256.226 236.885L255.839 239.558L251.072 238.882L250.943 239.751L252.972 240.041H253.069L254.841 240.299L254.229 244.615L252.489 244.357L252.425 244.744L252.328 244.712L251.652 249.285L249.236 248.963L248.882 251.443L248.592 251.411L240.057 250.187L240.089 249.801L241.377 249.962L241.538 248.963L242.827 249.157L242.955 248.126L244.276 248.319L244.598 245.936H244.63L244.92 243.906L246.209 244.1L246.498 241.942L247.787 242.135L248.077 240.106L246.788 239.912L246.885 239.172L247.851 239.3L248.141 237.11L249.719 237.336L249.913 236.015L250.041 234.888L248.495 234.662L248.141 237.11L240.958 236.112L241.313 233.664L227.012 231.635L226.657 234.083L217.317 232.762L217.639 230.314L198.442 227.609L197.766 232.214L195.447 231.892L195.06 234.469L192.29 234.05L192.644 231.474L193.289 231.57L194.126 225.547L195.704 225.773L195.833 224.71L196.51 220.072L199.247 220.458L198.603 225.096L217.993 227.834V227.802L227.366 229.122V229.155L250.396 232.408L258.674 233.567L258.319 236.08Z"
                fill="#041836"
            />
            <path
                d="M252.186 225.647L251.888 227.752L259.351 228.806L259.649 226.701L252.186 225.647Z"
                fill="#041836"
            />
            <path
                d="M256.999 242.779H256.612C256.838 242.586 256.999 242.586 256.999 242.779Z"
                fill="#041836"
            />
            <path
                d="M251.781 262.008L250.814 268.997L249.043 268.739L248.495 268.675L249.494 261.686L251.781 262.008Z"
                fill="#041836"
            />
            <path
                d="M249.043 268.74L248.366 273.603L246.112 273.281L245.79 275.6L245.757 275.665L247.529 275.89L247.046 279.369L245.274 279.111L244.727 282.912L244.566 284.039L243.632 283.91L242.15 283.717L241.764 286.39L236.964 285.714L236.9 285.263L237.319 282.267L240.829 282.751L240.894 282.364L243.76 282.783L244.308 278.982L244.791 275.503L244.823 275.471L242.44 275.117L242.762 272.798L245.145 273.152H245.242L245.919 268.353V268.321L248.495 268.675L249.043 268.74Z"
                fill="#041836"
            />
            <path
                d="M247.585 258.715L247.201 261.426L249.497 261.751L249.881 259.04L247.585 258.715Z"
                fill="#041836"
            />
            <path
                d="M245.851 253.899L245.215 258.396L247.607 258.734L248.243 254.237L245.851 253.899Z"
                fill="#041836"
            />
            <path
                d="M249.859 222.679L249.494 225.262L252.173 225.64L252.538 223.057L249.859 222.679Z"
                fill="#041836"
            />
            <path
                d="M245.919 268.321V268.353L222.084 265.003L222.406 262.62L246.241 266.002L245.919 268.321Z"
                fill="#041836"
            />
            <path
                d="M246.808 239.915L246.52 241.956L247.795 242.137L248.084 240.095L246.808 239.915Z"
                fill="white"
            />
            <path
                d="M247.946 219.763L247.581 222.346L249.877 222.67L250.242 220.087L247.946 219.763Z"
                fill="#041836"
            />
            <path
                d="M239.82 274.769L239.459 277.32L242.043 277.685L242.403 275.133L239.82 274.769Z"
                fill="#041836"
            />
            <path
                d="M246.498 241.941L246.208 244.099L244.92 243.906L245.5 239.751L246.788 239.912L246.498 241.941Z"
                fill="white"
            />
            <path
                d="M246.885 239.171L246.788 239.912L245.5 239.751L244.211 239.558L243.438 244.969H243.406L242.118 244.808L240.829 244.615L240.088 249.801L240.056 250.187L236.706 249.704L237.061 247.224L234.613 246.902L235.257 242.296L232.841 241.974L232.197 246.547L229.749 246.193L229.395 248.673L220.602 247.449L220.666 247.031L221.955 247.224L222.083 246.225L223.404 246.386L223.533 245.388L224.821 245.549L225.176 243.198L225.465 241.168L226.754 241.329L227.076 239.204L228.364 239.397L228.622 237.368L227.366 237.174L226.077 236.981L226.174 236.24L226.335 236.273L226.657 234.082L231.489 234.759L231.166 236.949L233.518 237.271L235.933 237.625L237.769 237.883L238.091 235.693L240.958 236.112L240.668 238.302L246.885 239.171Z"
                fill="#041836"
            />
            <path
                d="M244.92 243.906L244.63 245.935H244.598L244.727 245.162L243.439 244.969L244.212 239.558L245.5 239.751L244.92 243.906Z"
                fill="white"
            />
            <path
                d="M244.598 245.935L244.276 248.319L242.955 248.126L243.406 244.969H243.438L243.342 245.774L244.598 245.935Z"
                fill="white"
            />
            <path
                d="M243.445 245.008L243.337 245.773L244.612 245.953L244.72 245.188L243.445 245.008Z"
                fill="white"
            />
            <path
                d="M243.181 253.826L242.569 258.239L240.185 257.917L240.507 255.727L238.253 255.405L237.931 257.595L235.579 257.273L235.869 255.083L236.191 252.86L238.543 253.182L240.797 253.504L243.181 253.826Z"
                fill="#041836"
            />
            <path
                d="M245.983 217.161L245.649 219.521L247.946 219.846L248.279 217.486L245.983 217.161Z"
                fill="#041836"
            />
            <path
                d="M218.527 274.373L218.243 276.383L239.197 279.342L239.48 277.333L218.527 274.373Z"
                fill="#041836"
            />
            <path
                d="M242.955 248.125L242.826 249.156L241.538 248.963L242.118 244.808L243.406 244.969L242.955 248.125Z"
                fill="white"
            />
            <path
                d="M179.052 263.489H179.986C180.417 262.32 180.922 261.179 181.5 260.075L179.567 259.817L180.373 254.149L182.273 254.406L182.885 250.122L184.624 250.38L186.235 239.075L184.624 238.817L183.916 243.648L182.015 243.391L180.727 252.538L179.052 252.409L177.667 262.072L179.406 262.33L179.052 263.489Z"
                fill="#041836"
            />
            <path
                d="M241.538 248.963L241.377 249.961L240.089 249.8L240.829 244.615L242.118 244.808L241.538 248.963Z"
                fill="white"
            />
            <path
                d="M243.885 214.374L243.552 216.734L245.976 217.076L246.309 214.716L243.885 214.374Z"
                fill="#041836"
            />
            <path
                d="M243.555 216.761L243.226 219.089L245.65 219.431L245.978 217.103L243.555 216.761Z"
                fill="#B3D8F9"
            />
            <path
                d="M241.59 214.089L241.261 216.417L243.557 216.742L243.886 214.413L241.59 214.089Z"
                fill="#B3D8F9"
            />
            <path
                d="M236.905 211.008L236.562 213.432L243.897 214.469L244.24 212.046L236.905 211.008Z"
                fill="#041836"
            />
            <path
                d="M234.398 210.623L234.056 213.047L236.543 213.399L236.886 210.975L234.398 210.623Z"
                fill="#B3D8F9"
            />
            <path
                d="M233.614 252.506L233.002 256.887L230.651 256.564L230.941 254.374L228.686 254.052L228.364 256.242L226.013 255.92L226.303 253.73L226.625 251.508L229.009 251.83L231.263 252.152L233.614 252.506Z"
                fill="#041836"
            />
            <path
                d="M222.786 206.745L222.48 208.913L236.863 210.945L237.17 208.776L222.786 206.745Z"
                fill="#041836"
            />
            <path
                d="M227.365 237.183L227.077 239.224L228.353 239.405L228.641 237.364L227.365 237.183Z"
                fill="white"
            />
            <path
                d="M227.076 239.204L226.754 241.329L225.465 241.168L226.077 236.981L227.366 237.174L227.076 239.204Z"
                fill="white"
            />
            <path
                d="M225.466 241.168L225.176 243.197L225.272 242.424L224.016 242.231L224.757 236.82L226.078 236.981L225.466 241.168Z"
                fill="white"
            />
            <path
                d="M226.174 236.24L226.078 236.981L224.757 236.82L224.016 242.231H223.984L222.696 242.038L221.375 241.877L220.666 247.03L220.602 247.449L217.252 246.966L217.607 244.486L215.159 244.132L215.803 239.558L211.39 238.946L210.037 248.48L211.905 248.738L211.551 251.153L209.103 250.831L209.425 248.383L207.461 248.126L208.781 238.559L206.784 238.302L206.43 240.846L201.115 240.105L201.502 237.529L199.537 237.271L197.025 236.917L197.379 234.469L199.891 234.823L200.213 232.568L209.458 233.889L211.97 234.243L212.292 232.053L217.317 232.762L216.995 234.952L218.927 235.21L226.174 236.24Z"
                fill="#041836"
            />
            <path
                d="M225.176 243.198L224.821 245.549L223.533 245.388L223.984 242.231H224.016L223.887 243.004L225.176 243.198Z"
                fill="white"
            />
            <path
                d="M224.006 242.244L223.898 243.009L225.174 243.189L225.282 242.424L224.006 242.244Z"
                fill="white"
            />
            <path
                d="M220.45 259.809L220.094 262.328L222.391 262.653L222.746 260.133L220.45 259.809Z"
                fill="#041836"
            />
            <path
                d="M223.533 245.388L223.404 246.386L222.084 246.225L222.696 242.038L223.984 242.231L223.533 245.388Z"
                fill="white"
            />
            <path
                d="M218.916 254.46L218.564 256.947L221.084 257.303L221.435 254.816L218.916 254.46Z"
                fill="#041836"
            />
            <path
                d="M216.469 271.478L216.108 274.029L218.564 274.376L218.924 271.825L216.469 271.478Z"
                fill="#041836"
            />
            <path
                d="M222.084 246.225L221.955 247.224L220.666 247.031L221.375 241.877L222.696 242.038L222.084 246.225Z"
                fill="white"
            />
            <path
                d="M218.186 259.463V259.56L215.803 259.206L216.189 256.597L218.573 256.919L218.186 259.463Z"
                fill="#041836"
            />
            <path
                d="M211.555 251.171L211.244 253.371L218.898 254.453L219.209 252.252L211.555 251.171Z"
                fill="#041836"
            />
            <path
                d="M214.473 268.619L214.117 271.138L216.445 271.467L216.801 268.947L214.473 268.619Z"
                fill="#041836"
            />
            <path
                d="M213.32 258.887L211.991 268.296L214.479 268.647L215.808 259.239L213.32 258.887Z"
                fill="#041836"
            />
            <path
                d="M215.696 207.932L215.353 210.355L222.146 211.315L222.489 208.891L215.696 207.932Z"
                fill="#041836"
            />
            <path
                d="M210.312 209.657L209.983 211.985L215.022 212.697L215.351 210.369L210.312 209.657Z"
                fill="#041836"
            />
            <path
                d="M204.502 252.856L204.115 255.599L206.698 255.964L207.085 253.221L204.502 252.856Z"
                fill="#041836"
            />
            <path
                d="M197.279 254.686L196.973 256.855L203.798 257.819L204.104 255.65L197.279 254.686Z"
                fill="#041836"
            />
            <path
                d="M207.43 211.609L207.065 214.193L209.617 214.553L209.982 211.97L207.43 211.609Z"
                fill="#041836"
            />
            <path
                d="M202.694 247.481L202.372 249.833L200.149 249.543L197.927 249.221L198.281 246.869L198.603 244.615L198.925 242.231L203.338 242.875L203.016 245.227L200.826 244.937L200.503 247.159L202.694 247.481Z"
                fill="#041836"
            />
            <path
                d="M207.074 214.177L206.365 219.105L204.916 218.88L204.594 221.199L202.339 220.876L199.247 220.458L199.601 217.881L202.693 218.3L202.855 217.108L204.207 217.301L204.723 213.855L207.074 214.177Z"
                fill="#041836"
            />
            <path
                d="M195.091 251.859L194.744 254.314L197.264 254.67L197.61 252.215L195.091 251.859Z"
                fill="#041836"
            />
            <path
                d="M192.757 248.806L192.379 251.485L195.122 251.872L195.5 249.193L192.757 248.806Z"
                fill="#041836"
            />
            <path
                d="M194.459 236.618L194.071 239.36L196.654 239.726L197.042 236.983L194.459 236.618Z"
                fill="#041836"
            />
            <path
                d="M191.709 238.994L190.371 248.466L192.763 248.804L194.101 239.332L191.709 238.994Z"
                fill="#041836"
            />
            <path
                d="M189.823 233.75L189.48 236.174L191.936 236.521L192.279 234.097L189.823 233.75Z"
                fill="#041836"
            />
            <path
                d="M186.843 235.812L186.361 239.224L189.008 239.598L189.49 236.186L186.843 235.812Z"
                fill="#041836"
            />
            <path
                d="M243.149 286.261L238.607 288.323V285.102H242.955L243.149 286.261Z"
                fill="#041836"
            />
            <path
                d="M97.6258 103.892L97.3682 105.824H98.5277V107.467H97.0783L96.8206 109.432L95.1135 109.593L95.3712 107.628L93.4708 107.789L93.2132 109.754L91.5061 109.915L91.7637 107.95H90.7653V106.308H92.0536L92.3113 104.375H91.1518V102.7H92.6012L92.8589 100.8L94.566 100.639L94.3083 102.539H96.2086L96.4341 100.639L98.1734 100.478L97.9157 102.378H98.9142V104.021L97.6258 103.892ZM94.0184 104.214L93.7607 106.147L95.6611 105.953L95.9187 104.021L94.0184 104.214Z"
                fill="black"
            />
            <path
                d="M100.75 100.188L107.192 99.608V101.09L103.391 108.981L101.137 109.206L104.97 101.508L100.686 101.895L100.75 100.188Z"
                fill="black"
            />
            <path
                d="M116.179 106.437C116.029 106.787 115.797 107.096 115.503 107.339C115.174 107.609 114.804 107.826 114.408 107.983C113.963 108.147 113.496 108.244 113.023 108.273C112.554 108.355 112.074 108.355 111.606 108.273C111.205 108.212 110.821 108.07 110.478 107.854C110.16 107.665 109.895 107.399 109.705 107.081C109.508 106.774 109.407 106.415 109.415 106.05C109.363 105.569 109.465 105.085 109.705 104.665C109.991 104.263 110.366 103.933 110.8 103.699C110.443 103.546 110.132 103.301 109.898 102.99C109.681 102.641 109.559 102.242 109.544 101.831C109.542 101.488 109.608 101.149 109.737 100.832C109.893 100.503 110.112 100.207 110.382 99.9626C110.668 99.7076 110.995 99.5009 111.348 99.3506C111.769 99.1831 112.215 99.0852 112.668 99.0607C113.094 98.9789 113.531 98.9789 113.957 99.0607C114.335 99.1458 114.696 99.2985 115.02 99.5116C115.301 99.7011 115.533 99.9551 115.696 100.252C115.849 100.541 115.937 100.86 115.954 101.187C115.978 101.61 115.889 102.033 115.696 102.41C115.474 102.751 115.19 103.046 114.859 103.28C115.286 103.438 115.671 103.692 115.986 104.021C116.271 104.388 116.42 104.844 116.405 105.309C116.45 105.699 116.371 106.094 116.179 106.437ZM113.989 104.568C113.64 104.397 113.248 104.33 112.862 104.375C112.459 104.405 112.071 104.538 111.734 104.762C111.599 104.862 111.49 104.993 111.417 105.145C111.344 105.296 111.309 105.463 111.316 105.631C111.323 105.787 111.368 105.939 111.446 106.073C111.525 106.208 111.635 106.321 111.767 106.404C112.134 106.586 112.544 106.664 112.953 106.63C113.362 106.596 113.753 106.451 114.086 106.211C114.211 106.111 114.311 105.983 114.378 105.838C114.445 105.693 114.477 105.534 114.472 105.374C114.481 105.207 114.44 105.041 114.354 104.897C114.268 104.753 114.141 104.639 113.989 104.568ZM113.699 100.864C113.419 100.667 113.072 100.586 112.733 100.639C112.375 100.647 112.031 100.784 111.767 101.025C111.561 101.23 111.445 101.508 111.445 101.799C111.455 101.946 111.494 102.091 111.561 102.224C111.627 102.356 111.719 102.474 111.831 102.572C112.113 102.766 112.458 102.847 112.797 102.797C113.145 102.784 113.477 102.647 113.731 102.41C113.839 102.306 113.923 102.181 113.978 102.042C114.034 101.903 114.059 101.755 114.053 101.605C114.052 101.463 114.02 101.323 113.959 101.195C113.898 101.067 113.809 100.954 113.699 100.864Z"
                fill="black"
            />
            <path
                d="M126.131 104.279C125.977 104.844 125.726 105.378 125.39 105.857C125.106 106.34 124.734 106.766 124.295 107.113C123.792 107.405 123.231 107.581 122.652 107.629C122.084 107.672 121.514 107.595 120.977 107.403C120.479 107.214 120.028 106.917 119.657 106.534C119.287 106.128 118.992 105.659 118.787 105.149C118.58 104.557 118.461 103.939 118.433 103.313C118.427 102.683 118.502 102.055 118.658 101.445C118.837 100.894 119.098 100.372 119.431 99.8986C119.778 99.4491 120.203 99.067 120.688 98.7712C121.192 98.4904 121.754 98.3254 122.33 98.2881C122.896 98.2193 123.47 98.2855 124.005 98.4813C124.494 98.6713 124.934 98.9685 125.293 99.351C125.686 99.7521 125.983 100.236 126.163 100.768C126.398 101.341 126.518 101.953 126.517 102.572C126.489 103.159 126.358 103.737 126.131 104.279ZM124.295 101.477C124.19 101.166 124.038 100.872 123.844 100.607C123.678 100.374 123.456 100.186 123.2 100.06C122.938 99.9385 122.65 99.8832 122.362 99.8986C122.074 99.9266 121.797 100.026 121.557 100.188C121.307 100.354 121.097 100.574 120.945 100.833C120.776 101.134 120.656 101.46 120.591 101.799C120.54 102.184 120.54 102.574 120.591 102.958C120.603 103.341 120.668 103.721 120.784 104.086C120.871 104.398 121.013 104.693 121.203 104.955C121.38 105.199 121.612 105.397 121.879 105.535C122.154 105.605 122.442 105.605 122.717 105.535C123.004 105.502 123.28 105.403 123.522 105.245C123.757 105.063 123.964 104.846 124.134 104.601C124.2 104.368 124.254 104.131 124.295 103.893C124.328 103.517 124.328 103.14 124.295 102.765C124.34 102.337 124.34 101.905 124.295 101.477Z"
                fill="black"
            />
            <path
                d="M134.634 97.0963L134.859 102.636H136.051V104.247H134.859V106.179L132.927 106.373V104.408L128.482 104.794L128.095 103.442L132.895 97.2574L134.634 97.0963ZM132.83 99.9951L130.511 103.023L132.927 102.797L132.83 99.9951Z"
                fill="black"
            />
            <path
                d="M214.482 182.548L213.87 184.416H214.998L214.772 186.058L213.355 185.833L212.743 187.733L211.036 187.476L211.648 185.608L209.812 185.318L209.2 187.186L207.493 186.928L208.105 185.06H207.139L207.396 183.385L208.653 183.578L209.232 181.742L208.041 181.581L208.298 179.939L209.715 180.164L210.295 178.328L212.002 178.586L211.39 180.422L213.258 180.68L213.87 178.876L215.545 179.101L214.933 180.937H215.932L215.674 182.58L214.482 182.548ZM210.939 182.032L210.327 183.868L212.196 184.158L212.808 182.29L210.939 182.032Z"
                fill="black"
            />
            <path
                d="M224.693 186.96C224.429 187.467 224.08 187.924 223.662 188.313C223.256 188.684 222.771 188.959 222.245 189.118C221.692 189.233 221.122 189.233 220.57 189.118C220.003 189.042 219.462 188.832 218.991 188.506C218.538 188.203 218.154 187.808 217.864 187.346C217.567 186.853 217.37 186.306 217.284 185.736C217.188 185.117 217.188 184.487 217.284 183.868C217.377 183.243 217.562 182.635 217.832 182.064C218.093 181.556 218.442 181.098 218.863 180.711C219.277 180.352 219.759 180.078 220.28 179.906C220.831 179.776 221.404 179.776 221.955 179.906C222.519 179.971 223.06 180.17 223.533 180.486C223.979 180.797 224.362 181.191 224.66 181.645C224.953 182.141 225.149 182.688 225.24 183.256C225.337 183.875 225.337 184.505 225.24 185.124C225.154 185.761 224.969 186.38 224.693 186.96ZM223.243 183.739C223.208 183.405 223.121 183.079 222.985 182.773C222.868 182.511 222.692 182.279 222.47 182.096C222.246 181.896 221.964 181.772 221.665 181.742C221.392 181.662 221.101 181.662 220.827 181.742C220.564 181.842 220.331 182.009 220.151 182.225C219.918 182.48 219.732 182.774 219.603 183.095C219.465 183.459 219.368 183.837 219.314 184.222C219.265 184.607 219.265 184.997 219.314 185.382C219.349 185.715 219.436 186.041 219.571 186.348C219.697 186.614 219.872 186.855 220.087 187.057C220.321 187.234 220.599 187.345 220.892 187.379C221.163 187.474 221.458 187.474 221.729 187.379C221.998 187.271 222.239 187.106 222.438 186.896C222.66 186.639 222.835 186.344 222.953 186.026C223.088 185.672 223.185 185.305 223.243 184.931C223.294 184.524 223.294 184.113 223.243 183.707V183.739Z"
                fill="black"
            />
            <path
                d="M229.975 183.288C229.603 183.506 229.257 183.765 228.944 184.061L227.72 182.741C227.964 182.478 228.233 182.24 228.525 182.032C228.774 181.841 229.044 181.679 229.33 181.549C229.627 181.421 229.943 181.345 230.264 181.323C230.628 181.276 230.996 181.276 231.36 181.323C231.796 181.384 232.221 181.514 232.616 181.71C232.952 181.883 233.248 182.124 233.485 182.419C233.716 182.713 233.881 183.053 233.969 183.417C234.05 183.799 234.05 184.194 233.969 184.577C233.946 184.927 233.847 185.267 233.679 185.575C233.529 185.855 233.345 186.114 233.131 186.348C232.866 186.604 232.575 186.831 232.261 187.025L231.102 187.733L229.491 188.635L233.389 189.215L233.131 190.922L226.496 189.956L226.754 188.377L229.975 186.38L230.812 185.865L231.36 185.382C231.487 185.259 231.595 185.118 231.682 184.963C231.783 184.81 231.839 184.631 231.843 184.448C231.883 184.288 231.887 184.12 231.853 183.959C231.82 183.797 231.75 183.645 231.649 183.514C231.433 183.274 231.134 183.125 230.812 183.095C230.52 183.073 230.228 183.141 229.975 183.288Z"
                fill="black"
            />
            <path
                d="M243.277 189.762C243.019 190.272 242.67 190.73 242.247 191.115C241.841 191.469 241.371 191.743 240.862 191.92C240.3 192.051 239.716 192.051 239.155 191.92C238.595 191.835 238.058 191.638 237.576 191.34C237.131 191.025 236.758 190.619 236.481 190.149C236.189 189.665 235.992 189.129 235.902 188.57C235.788 187.942 235.788 187.298 235.902 186.67C235.991 186.051 236.188 185.451 236.481 184.899C236.723 184.378 237.075 183.917 237.512 183.546C237.913 183.168 238.399 182.892 238.929 182.74C239.468 182.577 240.037 182.536 240.594 182.62C241.151 182.703 241.683 182.909 242.15 183.224C242.607 183.512 242.983 183.911 243.245 184.383C243.543 184.877 243.74 185.424 243.825 185.994C243.938 186.611 243.938 187.244 243.825 187.862C243.756 188.523 243.571 189.166 243.277 189.762ZM241.86 186.541C241.825 186.208 241.738 185.882 241.603 185.575C241.476 185.3 241.289 185.058 241.055 184.866C240.831 184.685 240.565 184.563 240.282 184.512C240.007 184.447 239.72 184.447 239.445 184.512C239.176 184.635 238.936 184.81 238.736 185.027C238.522 185.278 238.348 185.561 238.221 185.865C238.06 186.223 237.952 186.603 237.898 186.992C237.867 187.378 237.867 187.766 237.898 188.152C237.937 188.499 238.035 188.837 238.188 189.15C238.304 189.413 238.48 189.645 238.704 189.827C238.927 190.008 239.193 190.13 239.477 190.181C239.752 190.248 240.039 190.248 240.314 190.181C240.589 190.069 240.832 189.892 241.023 189.665C241.249 189.424 241.425 189.139 241.538 188.828C241.702 188.471 241.811 188.091 241.86 187.701C241.91 187.305 241.91 186.905 241.86 186.509V186.541Z"
                fill="black"
            />
            <path
                d="M246.692 185.511L246.949 183.804L253.037 184.738L252.811 186.219L250.202 188.055C250.506 188.151 250.798 188.281 251.072 188.442C251.348 188.58 251.59 188.778 251.781 189.022C251.97 189.261 252.112 189.534 252.199 189.827C252.283 190.198 252.283 190.583 252.199 190.954C252.132 191.353 251.99 191.735 251.781 192.081C251.595 192.428 251.33 192.726 251.008 192.951C250.664 193.171 250.281 193.324 249.88 193.402C249.422 193.484 248.953 193.484 248.495 193.402C247.838 193.31 247.209 193.074 246.653 192.712C246.096 192.351 245.626 191.871 245.274 191.308L246.82 190.213C247.05 190.576 247.345 190.892 247.69 191.147C248.03 191.398 248.43 191.553 248.85 191.598C249.17 191.665 249.504 191.608 249.784 191.437C249.911 191.354 250.02 191.245 250.103 191.118C250.186 190.99 250.242 190.847 250.267 190.696C250.302 190.526 250.291 190.349 250.234 190.185C250.177 190.021 250.077 189.875 249.945 189.762C249.585 189.477 249.147 189.309 248.688 189.279H247.851V187.959L250.331 186.123L246.692 185.511Z"
                fill="black"
            />
            <path
                d="M186.879 307.552C186.601 307.707 186.31 307.837 186.009 307.938C185.673 308.037 185.327 308.101 184.978 308.132C184.582 308.162 184.183 308.162 183.787 308.132C183.158 308.04 182.556 307.82 182.015 307.487C181.496 307.187 181.046 306.781 180.694 306.296C180.332 305.808 180.079 305.248 179.954 304.653C179.822 304.037 179.822 303.401 179.954 302.785C180.04 302.16 180.248 301.558 180.566 301.013C180.863 300.502 181.257 300.054 181.725 299.693C182.209 299.311 182.769 299.036 183.368 298.888C184.007 298.773 184.661 298.773 185.3 298.888L186.428 299.145C186.744 299.263 187.046 299.414 187.33 299.596C187.592 299.742 187.831 299.926 188.038 300.144C188.266 300.346 188.472 300.573 188.65 300.82L187.169 302.076C186.896 301.726 186.57 301.422 186.202 301.174C185.853 300.92 185.441 300.764 185.01 300.723C184.661 300.643 184.297 300.643 183.948 300.723C183.613 300.812 183.305 300.978 183.046 301.207C182.76 301.431 182.529 301.718 182.369 302.044C182.185 302.361 182.065 302.711 182.015 303.075C181.934 303.446 181.934 303.831 182.015 304.202C182.076 304.557 182.207 304.897 182.402 305.201C182.59 305.491 182.844 305.734 183.142 305.909C183.428 306.136 183.777 306.271 184.141 306.296C184.584 306.412 185.05 306.412 185.494 306.296C185.899 306.13 186.287 305.925 186.653 305.684L187.716 307.133C187.452 307.302 187.172 307.442 186.879 307.552Z"
                fill="black"
            />
            <path
                d="M195.962 307.648C195.711 308.033 195.395 308.371 195.028 308.647C194.642 308.933 194.205 309.141 193.739 309.259C192.731 309.506 191.665 309.344 190.776 308.808C190.351 308.587 189.987 308.266 189.713 307.874C189.424 307.514 189.215 307.097 189.101 306.65C188.991 306.173 188.991 305.677 189.101 305.2C189.164 304.72 189.329 304.259 189.584 303.848C189.834 303.453 190.15 303.104 190.518 302.817C190.916 302.559 191.35 302.364 191.807 302.237C192.815 301.99 193.881 302.152 194.77 302.688C195.2 302.901 195.567 303.223 195.833 303.622C196.122 303.982 196.331 304.399 196.445 304.846C196.541 305.324 196.541 305.817 196.445 306.296C196.382 306.776 196.217 307.237 195.962 307.648ZM194.545 306.006C194.593 305.761 194.593 305.509 194.545 305.265C194.501 305.02 194.402 304.789 194.255 304.588C194.116 304.386 193.942 304.211 193.739 304.073C193.521 303.944 193.281 303.856 193.031 303.815C192.775 303.767 192.513 303.767 192.258 303.815L191.646 304.138C191.479 304.297 191.338 304.482 191.227 304.685C191.108 304.908 191.021 305.146 190.969 305.394C190.921 305.638 190.921 305.89 190.969 306.134C191.026 306.375 191.125 306.604 191.259 306.811C191.387 307.002 191.551 307.167 191.742 307.294C191.966 307.443 192.218 307.542 192.483 307.584C192.738 307.633 193.001 307.633 193.256 307.584C193.476 307.509 193.682 307.4 193.868 307.262C194.035 307.102 194.176 306.917 194.287 306.714C194.41 306.496 194.486 306.255 194.512 306.006H194.545Z"
                fill="black"
            />
            <path
                d="M204.465 308.904C204.233 309.312 203.914 309.664 203.531 309.935C203.146 310.221 202.708 310.429 202.243 310.547C201.732 310.644 201.207 310.644 200.697 310.547C200.195 310.489 199.712 310.324 199.279 310.064C198.875 309.814 198.516 309.498 198.217 309.13C197.937 308.752 197.729 308.327 197.605 307.874C197.491 307.408 197.491 306.922 197.605 306.456C197.662 305.975 197.827 305.512 198.088 305.104C198.338 304.71 198.654 304.361 199.022 304.073C199.412 303.782 199.864 303.584 200.342 303.493C200.84 303.373 201.359 303.373 201.856 303.493C202.358 303.551 202.841 303.716 203.273 303.976C203.693 304.205 204.056 304.524 204.336 304.91C204.616 305.288 204.824 305.714 204.948 306.167C205.046 306.645 205.046 307.138 204.948 307.616C204.882 308.075 204.717 308.515 204.465 308.904ZM203.048 307.262C203.096 307.017 203.096 306.765 203.048 306.521C202.998 306.288 202.899 306.068 202.758 305.877C202.629 305.667 202.452 305.491 202.243 305.361C202.031 305.218 201.788 305.13 201.534 305.104C201.279 305.056 201.017 305.056 200.761 305.104C200.536 305.165 200.327 305.275 200.149 305.426C199.975 305.579 199.833 305.765 199.73 305.973C199.608 306.192 199.531 306.433 199.505 306.682C199.457 306.926 199.457 307.178 199.505 307.423C199.568 307.651 199.666 307.868 199.795 308.067C199.915 308.284 200.093 308.462 200.31 308.582C200.755 308.85 201.288 308.931 201.792 308.808C202.017 308.746 202.225 308.636 202.404 308.486C202.586 308.332 202.739 308.146 202.855 307.938C202.954 307.71 203.029 307.473 203.08 307.229L203.048 307.262Z"
                fill="black"
            />
            <path
                d="M205.946 311.223L207.331 301.818L209.296 302.108L208.04 311.513L205.946 311.223Z"
                fill="black"
            />
            <path
                d="M220.441 313.382L219.925 311.256L216.125 310.676L215.03 312.576L213 312.286L218.186 303.783L220.022 304.073L222.502 313.736L220.441 313.382ZM218.734 306.457L217.091 309.194L219.475 309.549L218.734 306.457Z"
                fill="black"
            />
            <path
                d="M230.909 312.898C230.692 313.279 230.408 313.617 230.071 313.897C229.745 314.148 229.373 314.333 228.976 314.444C228.571 314.508 228.158 314.508 227.752 314.444C227.298 314.378 226.866 314.201 226.496 313.929C226.215 313.682 225.966 313.401 225.755 313.091L225.337 316.023L223.372 315.733L224.692 306.778L226.657 307.101V308.067C226.944 307.78 227.283 307.551 227.656 307.39C228.088 307.271 228.544 307.271 228.976 307.39C229.372 307.467 229.753 307.609 230.104 307.809C230.455 308.028 230.761 308.312 231.005 308.647C231.248 309.021 231.422 309.435 231.521 309.871C231.619 310.392 231.619 310.927 231.521 311.449C231.425 311.971 231.216 312.465 230.909 312.898ZM229.459 311.095C229.509 310.828 229.509 310.555 229.459 310.289C229.427 310.047 229.339 309.815 229.202 309.613C229.083 309.423 228.916 309.268 228.719 309.162C228.537 309.031 228.327 308.943 228.107 308.904C227.882 308.872 227.654 308.872 227.43 308.904C227.217 308.972 227.02 309.081 226.85 309.226C226.675 309.387 226.523 309.571 226.399 309.774C226.276 310.017 226.189 310.278 226.142 310.547C226.093 310.813 226.093 311.086 226.142 311.352C226.173 311.585 226.262 311.806 226.399 311.996C226.527 312.188 226.691 312.352 226.883 312.48C227.006 312.657 227.172 312.801 227.366 312.898C227.589 312.946 227.819 312.946 228.042 312.898C228.257 312.836 228.455 312.726 228.622 312.576C228.813 312.432 228.968 312.244 229.073 312.029C229.211 311.791 229.299 311.528 229.331 311.256L229.459 311.095Z"
                fill="black"
            />
            <path
                d="M239.187 313.124V313.349L234.42 312.64C234.411 312.842 234.444 313.043 234.516 313.231C234.588 313.42 234.698 313.591 234.838 313.736C235.11 314.024 235.475 314.206 235.869 314.251C236.166 314.316 236.474 314.316 236.771 314.251C237.084 314.165 237.378 314.023 237.641 313.832L238.607 314.992C238.231 315.346 237.779 315.61 237.286 315.765C236.747 315.897 236.183 315.897 235.644 315.765C235.148 315.682 234.669 315.519 234.226 315.282C233.826 315.052 233.476 314.746 233.196 314.38C232.927 314 232.73 313.575 232.616 313.124C232.534 312.633 232.534 312.132 232.616 311.642C232.745 310.702 233.215 309.842 233.937 309.226C234.283 308.954 234.676 308.746 235.096 308.614C235.563 308.517 236.046 308.517 236.513 308.614C237.027 308.682 237.521 308.857 237.963 309.13C238.338 309.396 238.656 309.736 238.897 310.128C239.126 310.523 239.269 310.962 239.315 311.417C239.38 311.898 239.38 312.385 239.315 312.866C239.25 312.939 239.206 313.028 239.187 313.124ZM237.029 310.74C236.925 310.583 236.787 310.452 236.625 310.357C236.463 310.263 236.282 310.206 236.095 310.193C235.917 310.155 235.733 310.156 235.555 310.195C235.377 310.234 235.21 310.31 235.064 310.418C234.753 310.684 234.519 311.029 234.387 311.417L237.318 311.867C237.349 311.47 237.247 311.074 237.029 310.74Z"
                fill="black"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_10025_65883"
                    x1="77.5735"
                    y1="121.093"
                    x2="76.74"
                    y2="111.936"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C88C4" />
                    <stop offset="1" stopColor="#2D5382" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_10025_65883"
                    x1="4281.88"
                    y1="-2494.71"
                    x2="4266.5"
                    y2="-2719.94"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3C88C4" />
                    <stop offset="1" stopColor="#2D5382" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_10025_65883"
                    x1="103.129"
                    y1="135.562"
                    x2="103.708"
                    y2="161.661"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_10025_65883"
                    x1="4877.37"
                    y1="-2455.66"
                    x2="4866.76"
                    y2="-2674.89"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_10025_65883"
                    x1="4050.19"
                    y1="-1594.61"
                    x2="4047.88"
                    y2="-1651.57"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_10025_65883"
                    x1="102.091"
                    y1="143.222"
                    x2="113.645"
                    y2="203.867"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#297EA4" />
                    <stop offset="1" stopColor="#25A6C4" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_10025_65883"
                    x1="57.6996"
                    y1="211.59"
                    x2="49.8105"
                    y2="211.722"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_10025_65883"
                    x1="3262.81"
                    y1="-8579.51"
                    x2="3008.25"
                    y2="-8551.41"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_10025_65883"
                    x1="3332.12"
                    y1="-8535.92"
                    x2="3077.65"
                    y2="-8508.54"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_10025_65883"
                    x1="3414.43"
                    y1="-8493.79"
                    x2="3159.87"
                    y2="-8465.69"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_10025_65883"
                    x1="3468.91"
                    y1="-8450.52"
                    x2="3214.51"
                    y2="-8423.16"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint11_linear_10025_65883"
                    x1="3531.91"
                    y1="-8411.89"
                    x2="3276.55"
                    y2="-8383.86"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint12_linear_10025_65883"
                    x1="3604.5"
                    y1="-8361.35"
                    x2="3350.64"
                    y2="-8334.1"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint13_linear_10025_65883"
                    x1="3701.6"
                    y1="-8331.63"
                    x2="3447.25"
                    y2="-8303.61"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint14_linear_10025_65883"
                    x1="5955.8"
                    y1="-9347.18"
                    x2="3937.6"
                    y2="-8431.03"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint15_linear_10025_65883"
                    x1="94.7274"
                    y1="160.763"
                    x2="198.741"
                    y2="132.572"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B2F5F2" />
                    <stop offset="1" stopColor="#F0FDFC" />
                </linearGradient>
                <linearGradient
                    id="paint16_linear_10025_65883"
                    x1="130.391"
                    y1="131.684"
                    x2="97.0185"
                    y2="192.442"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5D1780" />
                    <stop offset="0.25" stopColor="#6C2E93" />
                    <stop offset="0.78" stopColor="#946AC3" />
                    <stop offset="1" stopColor="#A584D8" />
                </linearGradient>
                <linearGradient
                    id="paint17_linear_10025_65883"
                    x1="804.269"
                    y1="-5073.99"
                    x2="660.938"
                    y2="-4992.14"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint18_linear_10025_65883"
                    x1="52.727"
                    y1="327.232"
                    x2="24.7372"
                    y2="287.292"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint19_linear_10025_65883"
                    x1="5996.68"
                    y1="-1089.78"
                    x2="6009.76"
                    y2="-751.983"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#297EA4" />
                    <stop offset="1" stopColor="#25A6C4" />
                </linearGradient>
                <linearGradient
                    id="paint20_linear_10025_65883"
                    x1="62.2186"
                    y1="313.009"
                    x2="176.478"
                    y2="144.095"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="0.51" stopColor="#38AFDB" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint21_linear_10025_65883"
                    x1="68.8317"
                    y1="236.144"
                    x2="163.463"
                    y2="236.144"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.04" stopColor="white" />
                    <stop offset="0.62" stopColor="white" stopOpacity="0" />
                    <stop offset="0.68" stopColor="white" stopOpacity="0.01" />
                    <stop offset="0.73" stopColor="white" stopOpacity="0.05" />
                    <stop offset="0.78" stopColor="white" stopOpacity="0.12" />
                    <stop offset="0.82" stopColor="white" stopOpacity="0.21" />
                    <stop offset="0.86" stopColor="white" stopOpacity="0.33" />
                    <stop offset="0.9" stopColor="white" stopOpacity="0.48" />
                    <stop offset="0.94" stopColor="white" stopOpacity="0.65" />
                    <stop offset="0.98" stopColor="white" stopOpacity="0.85" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint22_linear_10025_65883"
                    x1="49.4094"
                    y1="239.783"
                    x2="170.742"
                    y2="256.725"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint23_linear_10025_65883"
                    x1="1971.52"
                    y1="7454.02"
                    x2="6477.07"
                    y2="7933.42"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint24_linear_10025_65883"
                    x1="1350.3"
                    y1="-381.605"
                    x2="1484.01"
                    y2="-362.696"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint25_linear_10025_65883"
                    x1="1084.87"
                    y1="-345.785"
                    x2="1275.53"
                    y2="-318.824"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint26_linear_10025_65883"
                    x1="1106.25"
                    y1="-380.645"
                    x2="1224.46"
                    y2="-363.927"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint27_linear_10025_65883"
                    x1="1108.2"
                    y1="102.538"
                    x2="1205.03"
                    y2="116.231"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint28_linear_10025_65883"
                    x1="967.679"
                    y1="129.003"
                    x2="1051.99"
                    y2="140.925"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint29_linear_10025_65883"
                    x1="997.689"
                    y1="155.222"
                    x2="1107.05"
                    y2="170.687"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint30_linear_10025_65883"
                    x1="688.325"
                    y1="154.407"
                    x2="758.77"
                    y2="164.369"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#B2F5F2" />
                </linearGradient>
                <linearGradient
                    id="paint31_linear_10025_65883"
                    x1="129.748"
                    y1="186.991"
                    x2="88.7824"
                    y2="250.492"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E8B414" />
                    <stop offset="1" stopColor="#D7830A" />
                </linearGradient>
                <linearGradient
                    id="paint32_linear_10025_65883"
                    x1="138.115"
                    y1="181.477"
                    x2="119.746"
                    y2="209.938"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2A54D3" />
                    <stop offset="1" stopColor="#43E8E1" />
                </linearGradient>
                <linearGradient
                    id="paint33_linear_10025_65883"
                    x1="116.846"
                    y1="176.335"
                    x2="133.273"
                    y2="239.796"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#EDC418" />
                    <stop offset="1" stopColor="#C95900" />
                </linearGradient>
                <linearGradient
                    id="paint34_linear_10025_65883"
                    x1="113.133"
                    y1="200.155"
                    x2="123.719"
                    y2="206.296"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#D7830A" />
                    <stop offset="0.85" stopColor="#EABC16" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint35_linear_10025_65883"
                    x1="94.9211"
                    y1="199.65"
                    x2="140.691"
                    y2="199.65"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="0.67" stopColor="white" />
                    <stop offset="0.98" stopColor="white" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint36_linear_10025_65883"
                    x1="13296.5"
                    y1="5587.64"
                    x2="8364.04"
                    y2="4154.09"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint37_linear_10025_65883"
                    x1="285.364"
                    y1="260.257"
                    x2="147.831"
                    y2="239.054"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B2F5F2" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default pack;
